export const dateFormator = (date) => {
  // Original date string
  let dateStr = date;

  // Parse the date string into a Date object
  let dateObj = new Date(dateStr);

  // Extract the year, month, and day
  let year = dateObj.getFullYear();
  let month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  let day = dateObj.getDate().toString().padStart(2, '0');

  // Format as yyyy-MM-dd
  let formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

// Derives the business subdomain from the current hostname, e.g.
// "nightandday.dev.seamlessslot.co.uk" -> "nightandday".
// Falls back to 'nightandday' when the hostname has no subdomain part
// (e.g. localhost during local development).
export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return parts[0];
  }
  return 'nightandday';
};
